class PrintVouchersWorkflow {
    constructor(Alert, $http, locale, ResourceCommon) {
        this.key = 'print-vouchers';
        this.title = 'Print Vouchers';
        this.level = 'selected';
        this.alert = Alert;
        this.locale = locale;
        this.api = $http;
        this.resourceCommon = ResourceCommon;
    }

    action({}, store) {
        return this.locale.ready(['categories', 'sweetalerts'])
            .then(() => {
                this.api.post('vouchers/print', {
                    vouchers: store.getters.selectedFilters
                }).then(() => {
                    store.dispatch('getData');
                    this.alert.success('Job scheduled', 'The job was scheduled. Vouchers will get printed now');
                }, err => this.alert.handle(err))
            });
    }
}

angular
    .module('festzelt-os.vouchers.main')
    .factory('printVouchers', [
        'Alert',
        '$http',
        'locale',
        'ResourceCommon',
        (Alert, $http, locale, ResourceCommon) => new PrintVouchersWorkflow(Alert, $http, locale, ResourceCommon)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/workflows/print-vouchers.js